var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "btn btn-web",
      class: [_vm.btnPaymentDisabled],
      on: {
        click: function($event) {
          return _vm.onClickPayment()
        }
      }
    },
    [
      _vm._v(
        "\n  " +
          _vm._s(
            _vm.currencyFormatter(_vm.totalNumber, { code: _vm.currency })
          ) +
          "\n"
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f81d04e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f81d04e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/mobile/common/TotalPriceButton.vue
// module id = null
// module chunks = 